import angular from 'angular';

import CustomerApiService from './services/customer.api.service';
import TransactionApiService from './services/transaction.api.service';
import ProductApiService from './services/product.api.service';
import DashboardApiService from './services/dashboard.api.service';
import ProfileApiService from './services/profile.api.service';
import OverviewApiService from './services/overview.api.service';
import MarketingApiService from './services/marketing.api.service';
import AcrewardsApiService from './services/acrewards.api.service';
import AccountApiService from './services/account.api.service';
import BetOverviewApiService from './services/betoverview.api.service';
import PaymentOptionApiService from './services/paymentoption.api.service';
import MemberProductApiService from './services/memberproduct.api.service';
import TicketsApiService from './services/tickets.api.service';
import MemberRequestApiService from './services/memberrequest.api.service';

let apiModule = angular.module('app.api', [])
.service('CustomerApiService', CustomerApiService)
.service('TransactionApiService', TransactionApiService)
.service('ProductApiService', ProductApiService)
.service('DashboardApiService', DashboardApiService)
.service('ProfileApiService', ProfileApiService)
.service('OverviewApiService', OverviewApiService)
.service('MarketingApiService', MarketingApiService)
.service('AcrewardsApiService', AcrewardsApiService)
.service('AccountApiService', AccountApiService)
.service('BetOverviewApiService', BetOverviewApiService)
.service('PaymentOptionApiService', PaymentOptionApiService)
.service('MemberProductApiService', MemberProductApiService)
.service('TicketsApiService', TicketsApiService)
.service('MemberRequestApiService', MemberRequestApiService)
.name;

export default apiModule;



// WEBPACK FOOTER //
// ./client/app/api/api.module.js